import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularchanneltypeAPI = createAsyncThunk(
  "auth/channeltype/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.channelTypeAction("details", 1, id, 1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const initialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailschanneltypeSlice = createSlice({
  name: "get particular channeltype",
  initialState,
  reducers: {
    resetgetparticularchanneltype: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularchanneltypeAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularchanneltypeAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularchanneltypeAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularchanneltype } = getparticularDetailschanneltypeSlice.actions;
export const getparticularDetailschanneltypeReducer =
  getparticularDetailschanneltypeSlice.reducer;
